import { connect } from 'react-redux';

// selectors
import { getActiveScriptType } from 'current/selectors';


import { determineStartingView } from 'util/env';

// actions
import { setActiveScriptType } from 'current';

import ScriptTypeToggle from './ScriptTypeToggle';
import { trackAction } from 'util/analytics';

export default connect(
  (state) => ({
    activeScriptType: getActiveScriptType(state) || determineStartingView({})
  }),
  (dispatch) => ({
    onSelectScriptType: ({ id }) => {
      trackAction(`Switched to the ${id} tab on the left panel`);
      dispatch(setActiveScriptType(id));
    } 
  })
)(ScriptTypeToggle);
